import { Text } from '@gasbuddy/react-components';
import PropTypes from 'prop-types';
import React from 'react';
import StarRating from '../StarRating';

const ReviewStats = ({ name, rating, reviewCount }) => (
  <React.Fragment>
    <br />
    <StarRating
      name={name}
      rating={rating}
      size="small"
      filledStarColor="#FF9500"
      emptyStarColor="#FF9500"
    />
    <br />
    <Text>{`${reviewCount} reviews`}</Text>
  </React.Fragment>
);

ReviewStats.propTypes = {
  name: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  reviewCount: PropTypes.string.isRequired,
};

export default ReviewStats;
